import { type IStatusProps, Status, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IWidgetStatusTriggerProps<T extends string = string> = {
  items: T[]
  getConfigByStatus: (status: T) => IStatusProps
}

export const WidgetStatusTrigger = <T extends string = string>({
  items,
  getConfigByStatus,
}: IWidgetStatusTriggerProps<T>) => {
  if (!items.length) return <>select</>

  return (
    <div className={styles.box}>
      <div className={styles.group}>
        {items.map((status) => {
          return <Status key={status} {...getConfigByStatus(status)} emphasis={'low'} onlyIcon />
        })}
      </div>
      <Typography ariaLabel='TriggerStatus' variant='body-md-regular'>
        {items.length > 1 ? `${items.length} statuses` : getConfigByStatus(items[0]).title}
      </Typography>
    </div>
  )
}
